export enum ElementId {
  PointsInputLabelText = 'pointsInputLabelText',
  PointsInput = 'pointsInput',
  Error = 'error',
  ErrorText = 'errorText',
  StatusText = 'statusText',
}
